<template>
    <div class="total_search">
        <div class="fixed">
          <Head type='back' name='search' title='스탬프 검색' />
          <SearchBar/>
        </div>
        <div class="search_word">
            <SearchWords/>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Head from '@/components/Head.vue'
import SearchBar from '@/components/search/SearchBar.vue'
import SearchWords from '@/components/search/SearchWords.vue'
export default {
  name: 'Search',
  components: {
    Head,
    SearchBar,
    SearchWords
  },
  computed: {
    ...mapState(['searchWord', 'stampOpen', 'searchInfo'])
  },
  data () {
    return {
    }
  },
  mounted () {
    document.getElementById('app').classList.add('full_height')
  }
}
</script>
